export default __webpack_public_path__ + "static/media/151-savings.39d79d47.png";